import smoothScroll from 'smoothscroll'

export default function scrollToView ({
  element,
  adjustment = 0,
  delay = 200,
  min = -1,
  max = -1,
  inFrame = false,
  scrollingContextIdentifier,
  force = false
}) {
  const noopO = {}
  const noop = () => noopO
  const pos = element.getBoundingClientRect()
  const scrollingContext = scrollingContextIdentifier && window.document.querySelectorAll(scrollingContextIdentifier)[0]
  const scrollTop =
    inFrame && scrollingContext
      ? scrollingContext.scrollTop
      : document.documentElement.scrollTop || document.body.scrollTop
  const bodyHeight = document.body.clientHeight

  if (force || pos.top < 0 || pos.bottom > bodyHeight) {
    let scrollTo = pos.top + scrollTop + adjustment

    if (min !== -1) {
      scrollTo = Math.max(min, scrollTo)
    }
    if (max !== -1) {
      scrollTo = Math.min(max, scrollTo)
    }

    if (inFrame) {
      smoothScroll(scrollTo, delay, noop, scrollingContext)
    } else {
      smoothScroll(scrollTo, delay)
    }
  }
}
